import { Leaf } from 'lucide-react';
import { SUSTAINABILITY } from '../mock';

export default function Sustainability() {
  return (
    <section className="bg-[#f1ede5] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <span className="eyebrow">Sustainability</span>
            <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
              Designed with<br />
              <em className="text-[#b39352] italic">tomorrow in mind.</em>
            </h2>
            <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-lg">
              Every element of the refurbishment lowers running costs and improves environmental
              performance — a building that works harder for its occupiers and the planet.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
            {SUSTAINABILITY.map((s) => (
              <div key={s} className="flex items-center gap-4 py-4 border-t border-[#0d281e]/12 last:border-b">
                <Leaf size={18} className="text-[#b39352]" strokeWidth={1.5} />
                <span className="text-[14px] text-[#0d281e]">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
